export default __webpack_public_path__ + "static/media/Long Straddle.f566cdd2.svg";